// extracted by mini-css-extract-plugin
module.exports = {"supTitle":"section-title_supTitle__iC5Qt","sectionTitle":"section-title_sectionTitle__ggP0v","sideFlourish":"section-title_sideFlourish__23W7f"};